var _g;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHeaderTableta(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 768.067,
    height: 432.923,
    viewBox: "0 0 768.067 432.923",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(0.067)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_197",
    "data-name": "Rectangle 197",
    width: 768,
    height: 432.923,
    fill: "#ececec"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Linie",
    d: "M1645.263,1776.155s245.648-10.971,307.212-43.143,128.762-97.9,199.71-95.136,94.855,52.546,86.372,95.136-61.019,71.481-127.676,95.308-230.662,5.98-230.662,5.98-102.71-8.9-117.647,20.929-9.858,61.972,61.6,92.393,251.5-10.67,251.5-10.67,216.612-52.391,333.574-66.5",
    transform: "translate(-1645.263 -1558.347)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 3,
    strokeDasharray: "15 10"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines",
    "data-name": "Circles and lines",
    transform: "translate(661.364 36.346) rotate(87)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    transform: "translate(0 392.793)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 7.331,
    ry: 7.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 6.331,
    ry: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    transform: "translate(315.618 544.814)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.402,
    cy: 5.402,
    rx: 5.402,
    ry: 5.402,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.402,
    cy: 5.402,
    rx: 4.402,
    ry: 4.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    transform: "translate(131.958 477.678)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 7.331,
    ry: 7.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 6.331,
    ry: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    transform: "translate(146.62 419.03)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 3.858,
    ry: 3.858,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 2.858,
    ry: 2.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    transform: "translate(12.347 140.452)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 3.858,
    ry: 3.858,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 2.858,
    ry: 2.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    transform: "translate(172.857 588.028)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 7.331,
    ry: 7.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 6.331,
    ry: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82",
    "data-name": "Line 82",
    x2: 13.89,
    y2: 15.434,
    transform: "translate(62.12 407.84)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_85",
    "data-name": "Line 85",
    x1: 13.119,
    y2: 11.575,
    transform: "translate(50.633 0)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125",
    "data-name": "Path 1125",
    d: "M8.764,0,0,21.059",
    transform: "translate(23.261 559.09)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84",
    "data-name": "Line 84",
    x2: 16.977,
    y2: 4.63,
    transform: "translate(15.048 231.897)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86",
    "data-name": "Line 86",
    x1: 12.347,
    y2: 15.048,
    transform: "translate(263.53 477.678)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Circles_and_lines-2",
    "data-name": "Circles and lines",
    transform: "matrix(0.174, 0.985, -0.985, 0.174, 682, 93.323)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_62-2",
    "data-name": "Ellipse 62",
    transform: "translate(222.791 91.329)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.402,
    cy: 5.402,
    rx: 5.402,
    ry: 5.402,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 5.402,
    cy: 5.402,
    rx: 4.402,
    ry: 4.402,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_58-2",
    "data-name": "Ellipse 58",
    transform: "translate(127.6 43.366)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 7.331,
    ry: 7.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 6.331,
    ry: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_60-2",
    "data-name": "Ellipse 60",
    transform: "translate(166.471 0)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 3.858,
    ry: 3.858,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 3.858,
    cy: 3.858,
    rx: 2.858,
    ry: 2.858,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_59-2",
    "data-name": "Ellipse 59",
    transform: "translate(219.704 176.451)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 7.331,
    ry: 7.331,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.331,
    cy: 7.331,
    rx: 6.331,
    ry: 6.331,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_82-2",
    "data-name": "Line 82",
    x2: 13.89,
    y2: 15.434,
    transform: "translate(58.487 47.246)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1125-2",
    "data-name": "Path 1125",
    d: "M8.764,0,0,21.059",
    transform: "translate(64.994 155.322)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1126",
    "data-name": "Path 1126",
    d: "M0,0,12.859,18.7",
    transform: "translate(223.507 300.806)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_84-2",
    "data-name": "Line 84",
    x2: 16.977,
    y2: 4.63,
    transform: "translate(0 156.044)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_86-2",
    "data-name": "Line 86",
    x1: 12.347,
    y2: 15.048,
    transform: "translate(276.154 43.238)",
    fill: "none",
    stroke: "#8f6f6f",
    strokeWidth: 2
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderTableta);
export default __webpack_public_path__ + "static/media/headerTableta.cf8370aa894da81e50b1f062196a0763.svg";
export { ForwardRef as ReactComponent };